import { useEffect, useState } from 'react';
import { post } from '../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../constents';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TeleMedicineSection from './TeleMedicineSection';

import SelectProblem from './SelectProblem';

import { format } from 'date-fns';
import setUiMessage from '../../Utilities/Tostify';
import CopyFromLastVisitDropDown from '../../Utilities/CopyFromLastVisitDropDown';
import SelectMultiProcCode from './SelectMultiProcCode';
import { useRef } from 'react';
import { setRenderFormData } from '../../redux/slices/Notes/counsellingNoteSlice';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../Button';

function SuperBillPopup({
  handleClose,
  patientId,
  appointmentId,
  visitId,
  soapId,
  handleReload,
  appGrpId = '0',
  templateId,
}) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { defaultTimeFormat } = useSelector((store) => store.app);
  const [allData, setAllData] = useState(false);
  const [provider, setProvider] = useState('');
  const [resource, setResource] = useState('');
  const [pieType, setPieType] = useState(0);
  const [location, setLocation] = useState(0);

  const [telePatLoc, setTelePatLoc] = useState('');
  const [teleProLoc, setTeleProLoc] = useState('');
  const [teleAdd, setTeleAdd] = useState('');
  const [patAware, setPatAware] = useState('1');
  const [teleConsent, setTeleConsent] = useState('1');

  const [appDate, setAppDate] = useState(new Date());
  const [appDatePickerIsOpen, setAppDatePickerIsOpen] = useState(false);

  const [fromTime, setFromTime] = useState(null);
  const [fromTimePickerIsOpen, setFromTimePickerIsOpen] = useState(false);

  const [toTime, setToTime] = useState(null);
  const [toTimePickerIsOpen, setToTimePickerIsOpen] = useState(false);
  const [duration, setDuration] = useState('');
  const [mod1, setMod1] = useState(0);
  const [mod2, setMod2] = useState(0);
  const [mod3, setMod3] = useState(0);
  const [mod4, setMod4] = useState(0);
  //const [unit, setUnit] = useState([]);

  const [referrer, setReferrer] = useState('');
  const [procId, setProcId] = useState('');
  const [procFrom, setProcFrom] = useState(3);
  const [probIds, setProbIds] = useState('');
  const [lastVisitData, setLastVisitData] = useState('');
  const [teleMedBox, setTeleMedBox] = useState(false);

  const [patientChkBox, setPatientChkBox] = useState({
    presentPatient: false,
    presentPatientFamily: false,
    presentOnlyFamily: false,
    presentOther: false,
  });

  const patLocRef = useRef(null);
  const proLocRef = useRef(null);

  const handleSperBillSave = async () => {
    try {
      if (provider === '') {
        setUiMessage('err', 'Please select provider.');
      } else if (resource === '') {
        setUiMessage('err', 'Please select resource.');
      } else if (teleMedBox && (telePatLoc === '' || teleProLoc === '')) {
        if (telePatLoc === '') {
          setUiMessage('err', 'Please select patient location.');
          patLocRef.current.focus();
        } else if (teleProLoc === '') {
          setUiMessage('err', 'Please select provider location.');
          proLocRef.current.focus();
        }
      } else if (toTime < fromTime) {
        setUiMessage('err', 'End time should not be less than start time.');
      } else if (!procId) {
        setUiMessage('err', 'Select Procedure Code.');
      } else if (probIds.length === 0 && appGrpId === '0') {
        setUiMessage('err', 'Select Problem from the list.');
      } else {
        const response = await post(
          'api/patient/progressNote/saveCommonCounselingNoteForm',
          {
            patientId: patientId,
            soapId: soapId,
            appointmentId: appointmentId,
            timeFrom: format(fromTime, 'yyyy-MM-dd HH:mm:ss'),
            timeTo: format(toTime, 'yyyy-MM-dd HH:mm:ss'),
            pieNoteVisitDate: format(appDate, 'yyyy-MM-dd HH:mm:ss'),
            procedure: procId,
            procFrom: procFrom,
            problem: probIds,
            pieNoteProvider: provider,
            pieNoteResource: resource,
            pieType: pieType,
            pieLocation: location,
            referrer: referrer,
            mod1: mod1 || 0,
            mod2: mod2 || 0,
            mod3: mod3 || 0,
            mod4: mod4 || 0,
            locAddress: teleAdd,
            patientLocation: telePatLoc,
            providerLocation: teleProLoc,
            pfaForProvLoc: patAware,
            pfcForTel: teleConsent,
            appGroupId: appGrpId,
            presentPatient: patientChkBox?.presentPatient ? '1' : '0',
            presentPatientFamily: patientChkBox?.presentPatientFamily
              ? '1'
              : '0',
            presentOnlyPatient: patientChkBox?.presentOnlyFamily ? '1' : '0',
            presentOther: patientChkBox?.presentOther ? '1' : '0',

            staffUserId: user.id,
            tempId: templateId,
          },
        );
        if (response.status === 200) {
          handleClose();
          handleReload('superBill');

          dispatch(
            setRenderFormData({
              data: { genDetail: response.data.genDetail },
              type: 'superBill',
            }),
          );
        }
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/showCommonFormPopUp',
          {
            patientId: patientId,
            appointmentId: appointmentId,
            visitId: visitId,
            soapId: soapId,
          },
        );
        if (response.status === 200) {
          setAllData(response?.data);
          setProvider(
            response?.data?.rendercommonFormData?.pieNoteProvider || '',
          );
          setResource(
            response?.data?.rendercommonFormData?.pieNoteResource || '',
          );
          setPieType(response?.data?.rendercommonFormData?.pieType);
          setLocation(response?.data?.rendercommonFormData?.pieLocation);
          setMod1(response?.data?.rendercommonFormData?.modifier_one);
          setMod2(response?.data?.rendercommonFormData?.modifier_two);
          setMod3(response?.data?.rendercommonFormData?.modifier_three);
          setMod4(response?.data?.rendercommonFormData?.modifier_four);
          //setUnit(response?.data?.rendercommonFormData?.unit);
          setProcFrom(response?.data?.rendercommonFormData?.procedureForm || 2);
          //setProcId(response?.data?.rendercommonFormData?.procedure_id);
          setDuration(response?.data?.rendercommonFormData?.duration || '');
          setReferrer(response?.data?.rendercommonFormData?.referrer);
          //check
          setTelePatLoc(
            response?.data?.rendercommonFormData?.patient_location || '',
          );
          setTeleAdd(response?.data?.rendercommonFormData?.location_address);
          setTeleProLoc(
            response?.data?.rendercommonFormData?.provider_location || '',
          );
          setPatAware(
            response?.data?.rendercommonFormData?.pfa_provider_loc || '1',
          );
          setTeleConsent(
            response?.data?.rendercommonFormData?.pfc_telemedicine || '1',
          );

          setAppDate(
            new Date(response?.data?.rendercommonFormData?.appVisitDate),
          );

          setFromTime(
            (response?.data?.rendercommonFormData?.timeFrom &&
              new Date(response?.data?.rendercommonFormData?.timeFrom)) ||
              new Date(),
          );
          setToTime(
            (response?.data?.rendercommonFormData?.timeTo &&
              new Date(response?.data?.rendercommonFormData?.timeTo)) ||
              null,
          );
          setPatientChkBox({
            presentPatient:
              response?.data?.rendercommonFormData?.present_patient &&
              response?.data?.rendercommonFormData?.present_patient !== '0'
                ? true
                : false,
            presentPatientFamily:
              response?.data?.rendercommonFormData?.present_patient_family &&
              response?.data?.rendercommonFormData?.present_patient_family !==
                '0'
                ? true
                : false,
            presentOnlyFamily:
              response?.data?.rendercommonFormData?.present_only_family &&
              response?.data?.rendercommonFormData?.present_only_family !== '0'
                ? true
                : false,
            presentOther:
              response?.data?.rendercommonFormData?.present_other &&
              response?.data?.rendercommonFormData?.present_other !== '0'
                ? true
                : false,
          });
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [patientId, appointmentId, visitId, soapId]);

  function openDatePicker() {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  function openFromTimePicker() {
    setFromTimePickerIsOpen(!fromTimePickerIsOpen);
  }

  function handlFromTimeSelect(dateEvent) {
    setFromTime(dateEvent);
    setFromTimePickerIsOpen(!fromTimePickerIsOpen);
  }

  function openToTimePicker() {
    setToTimePickerIsOpen(!toTimePickerIsOpen);
  }

  function handlToTimeSelect(dateEvent) {
    setToTime(dateEvent);
    setToTimePickerIsOpen(!toTimePickerIsOpen);
    setDuration(timeDiffInMinutes(fromTime, toTime));
  }

  useEffect(() => {
    if (Date.parse(toTime) <= Date.parse(fromTime)) {
      setDuration(0);
    } else {
      setDuration(timeDiffInMinutes(fromTime, toTime) || 0);
    }
  }, [fromTime, toTime]);

  function timeDiffInMinutes(fromTimes, toTimes) {
    const fromTime = Date.parse(fromTimes);
    const toTime = Date.parse(toTimes);

    if (fromTime && toTime) {
      const diffInMin = Math.ceil(Math.abs(toTime - fromTime) / (60 * 1000), 2);
      return diffInMin;
    }
  }

  const handleProcCode = (data, procFrom) => {
    setProcFrom(procFrom);
    let procId =
      data.length > 0 &&
      data
        .map(
          (item) => item.procId + '_' + item?.evaluateCodeId + '_' + item.unit,
        )
        .join(',');

    // let unitObj = {};
    // data.forEach((item) => {
    //   unitObj[`unit_${item?.procId}_${item?.evaluateCodeId}`] = item.unit;
    // });
    setProcId(procId);
    //setUnit(unitObj);
  };

  const handleproblems = (data) => {
    setProbIds(data);
  };

  const handleReStoreLastVisitData = (data) => {
    setLastVisitData(data);
    let args = data.split('_');
    (async () => {
      try {
        const response = await post(
          'api/patient/progressNote/showCommonFormPopUp',
          {
            patientId: patientId,
            appointmentId: args[1],
            visitId: args[2],
            soapId: args[0],
          },
        );
        if (response.status === 200) {
          //setAllData(response?.data);
          setAllData((prevAllData) => {
            const { prefOrder, prefProbList } = prevAllData;
            return {
              ...response.data,
              prefOrder: prefOrder,
              prefProbList: prefProbList,
            };
          });
          setMod1(response?.data?.rendercommonFormData?.modifier_one);
          setMod2(response?.data?.rendercommonFormData?.modifier_two);
          setMod3(response?.data?.rendercommonFormData?.modifier_three);
          setMod4(response?.data?.rendercommonFormData?.modifier_four);
          setProcFrom(response?.data?.rendercommonFormData?.procedureForm || 2);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr prgrs-gnr-dtl center-popup">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info" style={{ width: '70%' }}>
            <span className="blacplan-eNm-lbl">Service Details: </span>
            {allData?.patientName}
            <span className="red"> | </span>
            ID: {allData?.chartNo}
            <span className="red"> | </span>
            {allData?.age} yrs-[{allData?.gender?.substr(0, 1)}]
            <span className="red"> | </span>
            DOB:{allData?.dob}
          </div>
          <div
            className="hdr-pt-info"
            style={{ width: '30%', display: 'flex' }}
          >
            <span style={{ width: '38%', paddingTop: '5px' }}>Copy form:</span>
            <CopyFromLastVisitDropDown
              dataArr={allData}
              selectedVal={lastVisitData}
              calback={(selectedOption) =>
                handleReStoreLastVisitData(selectedOption?.value)
              }
            />
            {/* <select
              className="book-appt-dd"
              value={lastVisitData || ''}
              onChange={(e) => handleReStoreLastVisitData(e.target.value)}
            >
              <option value="">{''}</option>
              {allData?.lastVisArr?.map((data, i) => (
                <option
                  key={i}
                  value={`${data?.soapId}_${data?.appointment_id}_${data?.visitId}`}
                >
                  {`${data?.consultDate} \n ${data?.resName.substr(
                    0,
                    6
                  )}...\n ${data?.typeOfVisit}`}
                </option>
              ))}
            </select> */}
          </div>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div className="main-contnr-bdy gnr-dtl-bdy">
          <div className="width50">
            <div className="appt-hx-fa-rw">
              <span className="label">Provider:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  data-placeholder="Select Provider"
                  value={provider || ''}
                  onChange={(e) => setProvider(e.target.value)}
                >
                  <option value="">{''}</option>
                  {allData?.providerList?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.providerName}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Resource:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={resource || ''}
                  onChange={(e) => setResource(e.target.value)}
                >
                  <option value="">{''}</option>
                  {allData?.resourceList?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.providerName}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Present:</span>
              <span className="asmnt-ptnt-demo-value assmntType">
                <input
                  className="clear-right10 clear-top10"
                  type="checkbox"
                  name="presentPatient"
                  checked={patientChkBox.presentPatient}
                  onChange={(event) => {
                    const { name, checked } = event.target;
                    setPatientChkBox({ ...patientChkBox, [name]: checked });
                  }}
                />
                Patient
                <input
                  className="clear-right10 clear-left10 clear-top10"
                  type="checkbox"
                  name="presentPatientFamily"
                  checked={patientChkBox.presentPatientFamily}
                  onChange={(event) => {
                    const { name, checked } = event.target;
                    setPatientChkBox({ ...patientChkBox, [name]: checked });
                  }}
                />
                Patient Family
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">&nbsp;</span>
              <span className="asmnt-ptnt-demo-value assmntType">
                <input
                  className="clear-right10 clear-top10"
                  type="checkbox"
                  name="presentOnlyFamily"
                  checked={patientChkBox.presentOnlyFamily}
                  onChange={(event) => {
                    const { name, checked } = event.target;
                    setPatientChkBox({ ...patientChkBox, [name]: checked });
                  }}
                />
                Only Family
                <input
                  className="clear-right10 clear-left10 clear-top10"
                  type="checkbox"
                  name="presentOther"
                  checked={patientChkBox.presentOther}
                  onChange={(event) => {
                    const { name, checked } = event.target;
                    setPatientChkBox({ ...patientChkBox, [name]: checked });
                  }}
                />
                Other
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Type:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={pieType || ''}
                  onChange={(e) => setPieType(e.target.value)}
                >
                  <option value="">{''}</option>
                  {allData?.piaTypeArr?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.name}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Location:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={location || ''}
                  onChange={(e) => setLocation(e.target.value)}
                >
                  <option value="">{''}</option>
                  {allData?.piaLocArr?.map((data, i) => (
                    <option key={i} value={data?.id}>
                      {data?.name}
                    </option>
                  ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Date:</span>
              <span
                className="value"
                style={{ display: 'flex', flexBasis: '62%' }}
              >
                <ReactDatePicker
                  selected={appDate || null}
                  onChange={(date) => setAppDate(date)}
                  onClickOutside={openDatePicker}
                  open={appDatePickerIsOpen}
                  onSelect={handleDateSelect}
                  className="app-date-picker"
                  dateFormat={DEFAULT_DATE_FORMATE}
                  maxDate={new Date()}
                />
                <img
                  width="13%"
                  src="./images/calendar-icon.png"
                  alt=""
                  onClick={openDatePicker}
                  style={{ marginLeft: '7px' }}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label"> Time (from - to):</span>
              <span
                className="app-time-picker"
                style={{ display: 'flex', alignItems: 'center', width: '61%' }}
              >
                <ReactDatePicker
                  selected={fromTime}
                  onClickOutside={openFromTimePicker}
                  onChange={(date) => handlFromTimeSelect(date)}
                  open={fromTimePickerIsOpen}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  // dateFormat="h:mm aa"
                  dateFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : 'h:mm aa'
                  } // Conditional date format
                  timeFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : undefined
                  } // Conditional time format
                  placeholderText="HH:MM"
                  className="app-date-picker"
                />
                <span
                  className="apptDate-time#"
                  style={{ marginRight: '5px', marginLeft: '5px' }}
                >
                  <AccessTimeIcon
                    fontSize="small"
                    color="orange"
                    sx={{ color: 'orange' }}
                    onClick={openFromTimePicker}
                  />
                </span>
                to&nbsp;
                <ReactDatePicker
                  selected={toTime || null}
                  onClickOutside={openToTimePicker}
                  onChange={(date) => handlToTimeSelect(date)}
                  open={toTimePickerIsOpen}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  // dateFormat="h:mm aa"
                  dateFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : 'h:mm aa'
                  } // Conditional date format
                  timeFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : undefined
                  } // Conditional time format
                  placeholderText="HH:MM"
                  className="app-date-picker"
                />
                <span
                  className="apptDate-time#"
                  style={{ marginRight: '5px', marginLeft: '5px' }}
                >
                  <AccessTimeIcon
                    fontSize="small"
                    color="orange"
                    sx={{ color: 'orange' }}
                    onClick={openToTimePicker}
                  />
                </span>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Duration:</span>
              <span className="value">
                <input
                  type="text"
                  className="apptTime"
                  placeholder="HH:MM"
                  value={duration || ''}
                  onChange={(e) => setDuration(e.target.value)}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Referrer:</span>
              <span className="value">
                <input
                  type="text"
                  className="apptTime"
                  placeholder=""
                  value={referrer || ''}
                  onChange={(e) => setReferrer(e.target.value)}
                />
              </span>
            </div>
            {allData && (
              <TeleMedicineSection
                appointmentId={allData?.appointmentId}
                telemedicine={allData?.telemedicine}
                telemedicineMode={allData?.telemedicineMode}
                telemedicineQcode={allData?.telemedicineQcode}
                returnDatafunc={(data) =>
                  setTeleMedBox(parseInt(data) === 1 ? true : false)
                }
              />
            )}
            {teleMedBox && (
              <>
                <div className="appt-hx-fa-rw tele-rw">
                  <span className="plan-eNm-lbl tele-lbl">
                    Patient's Physical location:
                  </span>
                  <span className="value">
                    <select
                      className="chzn-select chzn-done width100"
                      id="patientLocation"
                      value={telePatLoc || ''}
                      onChange={(e) => setTelePatLoc(e.target.value)}
                      ref={patLocRef}
                    >
                      <option value="">{''}</option>
                      {allData?.patientLocation?.map((data, i) => (
                        <option key={i} value={data?.id}>
                          {data?.val}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                <div className="appt-hx-fa-rw tele-rw">
                  <span className="plan-eNm-lbl tele-lbl">Patient's location detail:</span>
                  <span className="value">
                    <input
                      type="text"
                      className="eNm-otherText-box fontsize12"
                      placeholder="eg.:Hotel in Orlando, LF; Friend's home in Fairfax"
                      value={teleAdd || ''}
                      onChange={(e) => setTeleAdd(e.target.value)}
                    />
                  </span>
                </div>
                <div className="appt-hx-fa-rw tele-rw">
                  <span className="plan-eNm-lbl tele-lbl">
                    Provider's Physical location:
                  </span>
                  <span className="value">
                    <select
                      className="chzn-select chzn-done width100"
                      id="patientLocation"
                      value={teleProLoc || ''}
                      onChange={(e) => setTeleProLoc(e.target.value)}
                      ref={proLocRef}
                    >
                      <option value="">{''}</option>
                      {allData?.providerLocation?.map((data, i) => (
                        <option key={i} value={data?.id}>
                          {data?.val}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                <div className="appt-hx-fa-rw tele-rw2">
                  <span className="plan-eNm-lbl tele-lbl">
                    Patient/Family aware of the provider's location:
                  </span>
                  <span className="value">
                    <select
                      className="chzn-select chzn-done"
                      id="patientLocation"
                      value={patAware || '1'}
                      onChange={(e) => setPatAware(e.target.value)}
                    >
                      {allData?.pfa_provider_loc?.map((data, i) => (
                        <option key={i} value={data?.id}>
                          {data?.val}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                <div className="appt-hx-fa-rw tele-rw2">
                  <span className="plan-eNm-lbl  tele-lbl">
                    Patient/Family consent for Telemedicine:
                  </span>
                  <span className="value">
                    <select
                      className="chzn-select chzn-done"
                      id="patientLocation"
                      value={teleConsent || '1'}
                      onChange={(e) => setTeleConsent(e.target.value)}
                    >
                      {allData?.pfc_telemedicine?.map((data, i) => (
                        <option key={i} value={data?.id}>
                          {data?.val}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
              </>
            )}
          </div>
          <div className="width50">
            {allData && (
              // <SelectProcedureCode
              //   key={allData?.rendercommonFormData?.procedure_id}
              //   rendercommonFormData={allData?.rendercommonFormData}
              //   prefProc={allData?.prefOrder}
              //   patLabOrder={allData?.patLabOrder}
              //   patientId={patientId}
              //   calback={handleProcCode}
              // />
              <SelectMultiProcCode
                key={allData?.rendercommonFormData?.id}
                rendercommonFormData={allData?.rendercommonFormData}
                calback={handleProcCode}
                unitArr={allData?.unitArr}
                prefProc={allData?.prefOrder}
                patLabOrder={allData?.patLabOrder}
                patientId={patientId}
              />
            )}
            <div className="appt-hx-fa-rw grid-sec clear-top10">
              <div className="width100 flex-sec">
                {allData && (
                  <div className="width100 grid-sec">
                    <span className="width100">M1:</span>
                    <span className="width100">
                      <select
                        className="mod-dd"
                        value={mod1 || ''}
                        onChange={(e) => {
                          setMod1(e.target.value);
                          if (e.target.value === mod2) setMod2('');
                          if (e.target.value === mod3) setMod3('');
                          if (e.target.value === mod4) setMod4('');
                        }}
                      >
                        <option value="">{''}</option>
                        {allData?.modifier?.map((d, i) => (
                          <option key={i} value={d.id}>
                            {d.modifierName}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                )}
                {allData && (
                  <div className="width100 grid-sec">
                    <span className="width100">M2:</span>
                    <span className="width100">
                      <select
                        className="mod-dd"
                        value={mod2 || ''}
                        onChange={(e) => {
                          setMod2(e.target.value);
                          if (e.target.value === mod1) setMod1('');
                          if (e.target.value === mod3) setMod3('');
                          if (e.target.value === mod4) setMod4('');
                        }}
                      >
                        <option value="">{''}</option>
                        {allData?.modifier?.map((d, i) => (
                          <option key={i} value={d.id}>
                            {d.modifierName}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                )}
                {allData && (
                  <div className="width100 grid-sec">
                    <span className="width100">M3:</span>
                    <span className="width100">
                      <select
                        className="mod-dd"
                        value={mod3 || ''}
                        onChange={(e) => {
                          setMod3(e.target.value);
                          if (e.target.value === mod1) setMod1('');
                          if (e.target.value === mod2) setMod2('');
                          if (e.target.value === mod4) setMod4('');
                        }}
                      >
                        <option value="">{''}</option>
                        {allData?.modifier?.map((d, i) => (
                          <option key={i} value={d.id}>
                            {d.modifierName}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                )}
                {allData && (
                  <div className="width100 grid-sec">
                    <span className="width100">M4:</span>
                    <span className="width100">
                      <select
                        className="mod-dd"
                        value={mod4 || ''}
                        onChange={(e) => {
                          setMod4(e.target.value);
                          if (e.target.value === mod1) setMod1('');
                          if (e.target.value === mod2) setMod2('');
                          if (e.target.value === mod3) setMod3('');
                        }}
                      >
                        <option value="">{''}</option>
                        {allData?.modifier?.map((d, i) => (
                          <option key={i} value={d.id}>
                            {d.modifierName}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                )}
              </div>
              {/* <div className="width100 clear-top10">
                <span className="plan-eNm-lbl">Unit:</span>
                <span className="value">
                  <select
                    className="mod-dd"
                    style={{ width: '20%' }}
                    value={unit || ''}
                    onChange={(e) => setUnit(e.target.value)}
                  >
                    <option value=""></option>
                    {allData?.unitArr?.map((data, i) => (
                      <option key={i} value={data?.id}>
                        {data?.val}
                      </option>
                    ))}
                  </select>
                </span>
              </div> */}
            </div>

            {appGrpId === '0' && (
              <SelectProblem
                key={allData?.rendercommonFormData?.problemList}
                rendercommonFormData={
                  allData?.rendercommonFormData?.problemList || []
                }
                patActProbList={allData?.patActProbList}
                prefProbList={allData?.prefProbList}
                callBack={handleproblems}
                hadleProblemText={() => null}
              />
            )}
          </div>
        </div>
        <div className="gnrl-dtl-btn-rw">
          <button className="actn-yes" onClick={handleSperBillSave}>
            Save
          </button>
          <button className="actn-No" onClick={handleClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuperBillPopup;

// formate 03-30-2023 date n iso formate using datefns
